import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/Home'
import HomePC from '@/pages/home/HomePC'
import CommunityDetail from '@/pages/community/Detail'
import Privacy from '@/pages/account/Privacy'
import UserAgreement from '@/pages/account/UserAgreement'
import Download from '@/pages/settings/Download'
import Feedback from '@/pages/account/Feedback'
import Instructions from '@/pages/account/Instructions'
import SourceDescription from '@/pages/account/SourceDescription'

Vue.use(Router)

const routes = [
  {
    meta: {
      title: '主页'
    },
    name: 'Home',
    path: '/',
    component: Home
  },
  {
    meta: {
      title: '主页'
    },
    name: 'HomePC',
    path: '/pc',
    component: HomePC
  },
  {
    meta: {
      title: '帖子详情'
    },
    name: 'CommunityDetail',
    path: '/community/detail/:id',
    component: CommunityDetail
  },
  {
    meta: {
      title: '隐私条款'
    },
    name: 'Privacy',
    path: '/privacy',
    component: Privacy
  },
  {
    meta: {
      title: '用户协议'
    },
    name: 'UserAgreement',
    path: '/useragreement',
    component: UserAgreement
  },
  {
    meta: {
      title: '内容投诉渠道'
    },
    name: 'Feedback',
    path: '/feedback',
    component: Feedback
  },
  {
    meta: {
      title: '内容使用声明'
    },
    name: 'Instructions',
    path: '/instructions',
    component: Instructions
  },
  {
    meta: {
      title: '内容引用源说明'
    },
    name: 'SourceDescription',
    path: '/sourceDescription',
    component: SourceDescription
  },
  {
    meta: {
      title: 'APP下载'
    },
    name: 'Download',
    path: '/download',
    component: Download
  },
]

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  } else {
    return { x: 0, y: 0 }
  }
}
// mode: 'history',
// mode: 'hash',
const router = new Router({
  mode: 'history',
  base: '/',
  routes,
  scrollBehavior
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    window.document.title = to.meta.title;
  }
  next();
})

// router.afterEach((to, from) => {

// })

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js